import React, { Fragment } from 'react';


import {InputBoxFlat, UCardInfo, UTitle } from './utilities';



export class SingleOrderPackage extends React.Component {
    constructor(props) {
        super(props);
        this.dataChange = this.dataChange.bind(this);
    }

    dataChange(ev, who, value) {
        let nextWho = (this.props.name.indexOf(".") > -1) ? this.props.name.split(".").concat(who) : who.unshift(this.props.name);
        this.props.onChange(ev, nextWho, value);
    }

    // InputBoxFlat props -> data{id, width, type, text, value, class}, item, onChange
    render() {
        const intPadding = (this.props.padding === undefined) || !!this.props.padding.internal;
        const extPadding = !((this.props.padding === undefined) || !this.props.padding.external);
        const items = this.props.data.map((el, idx) => (<InputBoxFlat key={el.id} item={el.id} data={el} padding={intPadding} onChange={this.dataChange} />));
        const firstItem = items.shift();
        const sizeCol = (this.props.size === 0) ? "col" : (!this.props.size ? "col-5" : "col-" + this.props.size);  // col-5 is the default

        let title = (<UTitle text={this.props.title} textClass="bold upper blue" />);
        if (typeof this.props.title === "object") {
            title = (
                <UTitle name={"title." + this.props.name} text={this.props.title.text} textClass={this.props.title.class}
                    action={{ text: this.props.title.action.text, class: this.props.title.action.class }}
                    onClick={this.props.title.action.click} element={this.props.title.element} />
            );
        }
        return (
            <div className={"single-order-package" + (!this.props.disabled ? "" : " disabled")}>
                {title}
                <div className="row body no-margin">
                    <div className="small-cover" />
                    <div className={sizeCol}>
                        <div className="row entry">
                            <div className={"col col-9" + (extPadding ? " no-padding-right": " no-padding")}>{firstItem}</div>
                            <div className={"col no-padding"}>
                                <div className="square-measure-unit"><UCardInfo textClass="blue" text="KG" /></div>
                            </div>
                        </div>
                        <div className="row entry">
                            <div className={"col col-9" + (extPadding ? " no-padding-right" : " no-padding")}>{items}</div>
                            <div className={"col  no-padding"}>
                                <div className="square-measure-unit"><UCardInfo textClass="blue" text="CM" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




